module.exports = __webpack_public_path__ + "static/img/product4-1.7827494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product4-1.jpg
// module id = PvEW
// module chunks = 0